import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const DipStripIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="71"
      height="104"
      viewBox="0 0 71 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.0966 27.4061L26.1037 63.7638C19.2913 79.8319 30.5445 97.9131 47.3575 97.9131C64.1705 97.9131 75.4237 79.832 68.6113 63.7638L48.6185 27.4061C48.4979 27.1761 48.3166 26.9834 48.0944 26.8489C47.8721 26.7145 47.6173 26.6434 47.3575 26.6434C47.0978 26.6434 46.843 26.7145 46.6207 26.8489C46.3984 26.9834 46.2172 27.1761 46.0966 27.4061Z"
        fill="url(#paint0_linear_2205_7978)"
      />
      <path
        d="M47.3576 90.9317C46.9303 90.9317 46.5205 90.762 46.2183 90.4599C45.9162 90.1577 45.7465 89.7479 45.7465 89.3206C45.7465 88.8933 45.9162 88.4835 46.2183 88.1814C46.5205 87.8793 46.9303 87.7095 47.3576 87.7095C51.9691 87.7095 56.0617 85.383 58.5865 81.3268C59.8033 79.3881 60.5433 77.1886 60.7457 74.9086C60.9482 72.6286 60.6074 70.3331 59.7512 68.2103C59.5936 67.8131 59.6003 67.3696 59.7697 66.9773C59.9391 66.5851 60.2574 66.2761 60.6546 66.1186C61.0518 65.961 61.4953 65.9676 61.8876 66.137C62.2799 66.3064 62.5888 66.6247 62.7464 67.0219C63.7908 69.6128 64.2063 72.4144 63.9587 75.1969C63.7111 77.9794 62.8076 80.6636 61.3221 83.0295C58.1964 88.0515 53.1066 90.9317 47.3576 90.9317Z"
        fill="white"
      />
      <path
        d="M0.368652 0.919693H15.6372V103.08H0.368652V0.919693Z"
        fill="url(#paint1_linear_2205_7978)"
      />
      <path
        d="M0.368652 7.93393H15.6372V23.2024H0.368652V7.93393Z"
        fill="url(#paint2_linear_2205_7978)"
      />
      <path
        d="M0.368652 30.0843H15.6372V45.3528H0.368652V30.0843Z"
        fill="url(#paint3_linear_2205_7978)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2205_7978"
          x1="53.4496"
          y1="100.275"
          x2="41.7226"
          y2="48.9687"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0056" stopColor="#60B8FE" />
          <stop offset="1" stopColor="#00598E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2205_7978"
          x1="8.0029"
          y1="103.26"
          x2="8.0029"
          y2="27.5366"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0056" stopColor="#F9D9C0" />
          <stop offset="0.065" stopColor="#F9DDC7" />
          <stop offset="0.2304" stopColor="#FAE6D3" />
          <stop offset="0.4551" stopColor="#FAEBDA" />
          <stop offset="0.9988" stopColor="#FAECDC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2205_7978"
          x1="16.5713"
          y1="15.5682"
          x2="-3.37611"
          y2="15.5682"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0056" stopColor="#A2E0A7" />
          <stop offset="0.1996" stopColor="#89CFA7" />
          <stop offset="0.4448" stopColor="#70BEA7" />
          <stop offset="0.5922" stopColor="#66B7A7" />
          <stop offset="0.8324" stopColor="#52A8A7" />
          <stop offset="1" stopColor="#49A2A7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2205_7978"
          x1="0.368652"
          y1="37.7185"
          x2="15.6372"
          y2="37.7185"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0026" stopColor="#DF6A6A" />
          <stop offset="0.3672" stopColor="#E9766A" />
          <stop offset="1" stopColor="#F7876A" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}
